module.exports = __webpack_public_path__ + "img/bg-info.8e6c5ca8.png";